module.exports = __webpack_public_path__ + "img/16ne.113f7b45.svg";